import React, { useContext } from 'react';
import { AgFinancingPhase2Status } from '@indigo-ag/schema';

import i18next from 'core/i18n';
import { FinanceProcessContext } from 'features/brazil-grower/pages/BrazilGrowersDetail';
import { UserContext } from 'core/components/GateWay/GateWay';
import { Phase2Util } from 'shared';
import { UpdatePhase2StatusButtonDecisionModal } from '../UpdatePhase2StatusButtonDecisionModal/UpdatePhase2StatusButtonDecisionModal';

export const EscalatePhase2: React.FunctionComponent = () => {
  /**
   * Context
   */
  const { agFinance } = useContext(FinanceProcessContext);
  const { isCreditLead } = useContext(UserContext);

  if (isCreditLead || !Phase2Util.canEscalateToCM(agFinance?.phase2?.status)) {
    return null;
  }

  return (
    <UpdatePhase2StatusButtonDecisionModal
      phase2TargetStatus={AgFinancingPhase2Status.WAITING_COMMITTEE_DECISION}
      modalTitle={`${i18next.t('escalate')} ${i18next.t('phase')} 2`}
      buttonVariant="tertiary"
      buttonText={i18next.t('escalate')}
      onSuccessMessage={i18next.t('phase2WaitingCommittee')}
    />
  );
};
